"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseKeyToObjectArray = exports.QS_ARRAY_TUPLE_VALUE_SEPARATOR = exports.QS_TUPLE_SEPARATOR = void 0;
exports.QS_TUPLE_SEPARATOR = "=";
exports.QS_ARRAY_TUPLE_VALUE_SEPARATOR = ",";
// NOTE: parse query params in the format of test[]=bar=val1,val2,val3&test[]=foo=val11,val12,val13
// Will return {"bar": ["val1", "val2", "val3"], "foo": ["val11", "val12", "val13"]}
function parseKeyToObjectArray(objectTuples) {
    return objectTuples.map(objectTuple => {
        const [objKey, objValue] = objectTuple.split(exports.QS_TUPLE_SEPARATOR);
        const objValues = objValue.split(exports.QS_ARRAY_TUPLE_VALUE_SEPARATOR);
        const nonNullValues = objValues.filter(v => v !== "null");
        const transformedValues = (nonNullValues.length === objValues.length ? nonNullValues : [...nonNullValues, null]);
        return { [objKey]: transformedValues };
    }).reduce((accum, curr) => Object.assign(accum, curr), {});
}
exports.parseKeyToObjectArray = parseKeyToObjectArray;
//# sourceMappingURL=query-string-parser.js.map